// extracted by mini-css-extract-plugin
export var bottom = "Columns-module--bottom--7ee1d";
export var center = "Columns-module--center--43b48";
export var column = "Columns-module--column--bde3a";
export var columns = "Columns-module--columns--616e0";
export var constrain = "Columns-module--constrain--5680d";
export var deep = "Columns-module--deep--6a0a8";
export var stretch = "Columns-module--stretch--383ab";
export var top = "Columns-module--top--e3908";